import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router';
import { connect } from 'react-redux';

import { login } from '../../actions';

import APIConsoleContainer          from './APIConsole';
import RepeatTesterContainer        from './RepeatTester';
import FileUploaderContainer        from './FileUploader';
import GeneralInfoContainer         from './GeneralInfo';
import ChatContainer                from './ChatTester';

class Content extends Component {
  render() {
    return (
      <div className='Content'>
        <Switch>
          <Route
            path='/utilities/api-console/:method?/:subject?/:request?'
            render={
              (route) =>  <APIConsoleContainer
                            method={route.match.params.method}
                            subject={route.match.params.subject}
                            request={route.match.params.request}
                            {...this.props}
                          />}
          />
          <Route
            path='/utilities/repeat-tester'
            render={
              (route) =>  <RepeatTesterContainer
                            {...this.props}
                          />}
          />
          <Route
            path='/utilities/file'
            render={
              (route) =>  <FileUploaderContainer
                            {...this.props}
                          />}
          />
          <Route
            path='/utilities/info'
            render={
              (route) =>  <GeneralInfoContainer
                            {...this.props}
                          />}
          />
          <Route
            path='/utilities/chat'
            render={
              (route) =>  <ChatContainer
                            {...this.props}
                          />}
          />
          <Route render={() => (
            <Redirect to='/' />
          )} />
        </Switch>
      </div>
    );  
  }
}

export default connect(state => state, {
  login,
})(Content);



// WEBPACK FOOTER //
// ./src/containers/Utilities/Utilities.js